import type { FaireProductEntity } from "../../entity_types/product";

export const p_x2bnws2rzd: FaireProductEntity = {
  token: "p_x2bnws2rzd",
  type: "product",
  name: "Mindful Memory Game for Kids, Matching Pairs and Words",
  brandToken: "b_19ve7j7a7y",
  brandName: "Intelligent Change",
  imageUrl:
    "https://cdn.faire.com/fastly/8fdd740141cb611527910d6c55f2eefea2a89568d688047beda6e80c4b5cab08.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f7dbd31a14e29517c39740614d335257274dbe8a339ce179848678137100e60a.jpeg",
    "https://cdn.faire.com/fastly/3a20b3e9079493588c487ef11914518cc11759accf943774b2d728bb1e2deb49.jpeg",
    "https://cdn.faire.com/fastly/19d4a61c27ee28e4dd5afaf775141c7d41b92f6ebabb58c3a7c2541f270660e6.jpeg",
    "https://cdn.faire.com/fastly/9dd1aaf651521939753e0c19bec0f34154e6b30cecebf4f56266276b820eec02.jpeg",
    "https://cdn.faire.com/fastly/cce38c7be0657c453084490dfb022b5c344a8d718d1d1dbfe8bf07bdeee31770.jpeg",
    "https://cdn.faire.com/fastly/33972c7f867eec3bf066d413b7919906949ad3529483846a452e9b903dc6fb08.jpeg",
    "https://cdn.faire.com/fastly/2fa85eea96f192ee10a9f01f3113f47300c3fab2d4ec1812c0054d6a2c7f064e.jpeg",
    "https://cdn.faire.com/fastly/f59be160ee808927f99625d94d5e535461097061eb22759cf6a3e071f3e80123.jpeg",
  ],
  priceDollars: 21,
  description:
    "Mindful Memory Game combines classic matching with mindfulness, helping kids learn words like Gratitude and Patience while improving their vocabulary and memory. Designed for kids, seniors, and language learners, it’s a screen-free activity that makes learning feel effortless and fun. Perfect for family time or individual play, it makes a meaningful gift. \n\nDesigned by Intelligent Change, this bestselling item is a strong addition to retail assortments built around thoughtful gifts, mindfulness, and intentional living. Retailers frequently include it in seasonal displays for Easter basket stuffers, Mother’s Day gifts, graduation gifts, teacher gifts, and Father’s Day presents. Customers browsing for literary themed gifts, puzzles, games, and wellness products are drawn to items that encourage reflection and meaningful everyday moments. It fits naturally in bookstores, gift shops, and lifestyle stores alongside greeting cards, bookmarks, and other small giftable items. As demand grows for screen-free activities and mindful gifts, this product continues to perform well in spring, summer, and year-round gift collections.",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:40.943Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
